import React from 'react';
import { Typography } from '@eventbrite/marmalade';
import styles from './Address.module.scss';

interface Props {
  venueMultilineAddress?: string[];
  venueName?: string;
}

export const Address: React.FC<Props> = ({ venueMultilineAddress, venueName }) => {
  const [firstAddressLine, ...restAddressLines] = venueMultilineAddress || [];
  const restOfAddress = restAddressLines?.join(' ');

  return (
    <address className={styles.address}>
      {venueName && (
        <Typography as="h3" className={styles.name}>
          {venueName}
        </Typography>
      )}
      <div>
        {firstAddressLine && (
          <Typography as="p" className={styles.description}>
            {firstAddressLine}
          </Typography>
        )}
        {restOfAddress && (
          <Typography as="p" className={styles.description}>
            {restOfAddress}
          </Typography>
        )}
      </div>
    </address>
  );
};
